import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {ContactSchemaPassenger, contactSchemaPassenger} from "@/schemas/contact.schema";
import {ContactUsFormProps} from "@/constants/type/props";
import {useFormSubmit} from "@/hooks/useFormSubmit";

import FormWrapper from "./common/FormWrapper";
import FormField from "./common/FormField";


export default function ContactUsForm({onSuccess}: ContactUsFormProps) {
  const {handleSubmit, control, formState: {isSubmitting}, reset} = useForm<ContactSchemaPassenger>({
    resolver: yupResolver(contactSchemaPassenger),
    mode: "onSubmit",
  });

  const {errorMessage, handleSubmit: onSubmit} = useFormSubmit({
    contactType: "contact",
    onSuccess,
    reset,
  });

  const description = (
    <p>
      Contact us about anything related to our company or services.
      We'll do our best to get back to you as soon as possible.
    </p>
  );

  return (
    <FormWrapper
      title="Support"
      description={description}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitting={isSubmitting}
      errorMessage={errorMessage}
    >
      <div className="row d-flex">
        <FormField
          name="name"
          control={control}
          label="Name"
          type="text"
          className="col-md-4"
        />
        <FormField
          name="email"
          control={control}
          label="Email"
          type="email"
          className="col-md-4"
        />
      </div>

      <div className="row d-flex">
        <FormField
          name="phone"
          control={control}
          label="Phone"
          type="phone"
          className="col-md-4"
        />
        <FormField
          name="companyName"
          control={control}
          label="Company Name"
          type="text"
          className="col-md-4"
        />
      </div>

      <div className="row d-flex">
        <FormField
          name="subject"
          control={control}
          label="Subject"
          type="text"
          className="col-md-6"
        />
      </div>

      <div className="row d-flex">
        <FormField
          name="question"
          control={control}
          label="Question"
          type="textarea"
          className="col-md-6"
          rows={5}
        />
      </div>
    </FormWrapper>
  );
}
